(function () {
    'use strict';

    angular.module("imApp").factory("productLangService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductLanguage: function (parms) {
                return $ihttp.post({
                    method: 1083,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1084,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
